<template>
  <button class="cursor-pointer text-slate-white" @pointerup="landingpage()" @keydown.enter="landingpage()">{{ t('resources') }}</button>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'

  const router = useRouter()

  const { t } = useI18n()

  function landingpage() {
    router.push('/')
  }
</script>

<style scoped></style>
